<script setup>
import { usePlanningStore } from '@/stores/planning.store'

const { roiBarToneEnum: TONE } = usePlanningStore()

defineProps({
  width: {
    type: Number,
    required: true,
  },
  tone: {
    type: Number,
    required: true,
  },
})

const TONE_CLASS = Object.freeze({
  [TONE.MUTED]: 'roi-bar__fill--muted',
  [TONE.BEST]: 'bg-primary',
  [TONE.NEGATIVE]: 'bg-negative',
})
</script>

<template>
  <div class="roi-bar">
    <div class="roi-bar__fill" :class="TONE_CLASS[tone]" :style="{ width: `${width}%` }" />
  </div>
</template>

<style scoped>
.roi-bar {
  height: .375rem;
  border-radius: .1875rem;
  background-color: color-mix(in srgb, var(--q-primary) 8%, transparent);
  margin: .25rem 0;
  overflow: hidden;
}
.roi-bar__fill {
  height: 100%;
  border-radius: .1875rem;
}
.roi-bar__fill--muted {
  background-color: color-mix(in srgb, var(--q-primary) 55%, transparent);
}
</style>
